// Úradný jazyk priradený ku každému trhu (krajine) uvedenia na trh - používa sa na to, aby sa pri
// výbere trhu (napr. CZ) v PPWR obalovej jednotke ponúkla možnosť zadať preklad textových polí
// (názov komponentu, poznámka, použitie, popis obalu) v danom jazyku. Kód je ISO 639-1.
// Pozn.: viacjazyčné krajiny (napr. BE, LU) majú zámerne zvolený jeden reprezentatívny jazyk.
export const COUNTRY_LANGUAGE = {
    SK: 'sk',
    CZ: 'cs',
    AT: 'de',
    BE: 'nl',
    BG: 'bg',
    CY: 'el',
    DE: 'de',
    DK: 'da',
    EE: 'et',
    ES: 'es',
    FI: 'fi',
    FR: 'fr',
    GR: 'el',
    HR: 'hr',
    HU: 'hu',
    IE: 'en',
    IT: 'it',
    LT: 'lt',
    LU: 'fr',
    LV: 'lv',
    MT: 'mt',
    NL: 'nl',
    PL: 'pl',
    PT: 'pt',
    RO: 'ro',
    SE: 'sv',
    SI: 'sl',
};

export const LANGUAGE_LABELS = {
    sk: 'Slovenčina',
    cs: 'Čeština',
    de: 'Nemčina',
    nl: 'Holandčina',
    bg: 'Bulharčina',
    el: 'Gréčtina',
    da: 'Dánčina',
    et: 'Estónčina',
    es: 'Španielčina',
    fi: 'Fínčina',
    fr: 'Francúzština',
    hr: 'Chorvátčina',
    hu: 'Maďarčina',
    en: 'Angličtina',
    it: 'Taliančina',
    lt: 'Litovčina',
    lv: 'Lotyština',
    mt: 'Maltčina',
    pl: 'Poľština',
    pt: 'Portugalčina',
    ro: 'Rumunčina',
    sv: 'Švédčina',
    sl: 'Slovinčina',
};

// Základné textové polia (component/note/usage/description) sú vždy v slovenčine - preklady
// sa ponúkajú len pre ostatné jazyky trhov, ktoré boli vybrané pre danú obalovú jednotku.
export const BASE_LANGUAGE = 'sk';

// Vráti zoznam unikátnych jazykových kódov (bez základného jazyka) pre dané krajiny trhu,
// v stabilnom poradí podľa toho, ako idú za sebou v zozname krajín.
export const getMarketLanguages = (marketCountries = []) => {
    const codes = [];
    marketCountries.forEach((country) => {
        const lang = COUNTRY_LANGUAGE[country];
        if (lang && lang !== BASE_LANGUAGE && !codes.includes(lang)) codes.push(lang);
    });
    return codes;
};
